import { defineMessages } from 'react-intl';

const messages = defineMessages({
  socialTitle: { id: 'modules-default-landingReferral-socialTitle' },
  profileAboutTitle: { id: 'modules-default-landingReferral-profileAboutTitle' },
  formInfo: { id: 'modules-default-landingReferral-formInfo' },
  title: {
    id: 'default-landing-referral-title',
    defaultMessage: 'Service Empfehlung',
  },
  description: {
    id: 'default-landing-referral-description',
    defaultMessage: 'Diesen Service empfehle ich Euch gerne weiter!',
  },
});

export default messages;
